import axios from "axios";
import { LINK } from "../../config/config";

/**
 * Fetches the generated Foot Health Report PDF for a single scan.
 *
 * GET /scans/foot-health-report?scan_object_id=...&download=1 renders the report on the
 * server and streams it back inline, so the browser only ever handles a finished PDF.
 */
const fetchFootHealthReport = async (scanObjectId: string): Promise<Blob> => {
	const token = localStorage.getItem("@jwt");
	const response = await axios.get(`${LINK}/scans/foot-health-report`, {
		params: { scan_object_id: scanObjectId, download: 1 },
		responseType: "blob",
		headers: token ? { Authorization: `Bearer ${token}` } : {}
	});

	return new Blob([response.data], { type: "application/pdf" });
};

export const downloadFootHealthReport = async (scanObjectId: string, fileName: string): Promise<void> => {
	const blob = await fetchFootHealthReport(scanObjectId);
	const blobUrl = window.URL.createObjectURL(blob);

	const anchor = document.createElement("a");
	anchor.href = blobUrl;
	anchor.download = `${fileName}.pdf`;
	document.body.appendChild(anchor);
	anchor.click();
	anchor.remove();

	window.URL.revokeObjectURL(blobUrl);
};

export const printFootHealthReport = async (scanObjectId: string): Promise<void> => {
	const blob = await fetchFootHealthReport(scanObjectId);
	const blobUrl = window.URL.createObjectURL(blob);

	// The PDF is printed from a hidden iframe so the user stays on the grid. The iframe
	// has to outlive the print call - tearing it down immediately cancels the dialog -
	// so cleanup is deferred rather than done on the next line.
	const iframe = document.createElement("iframe");
	iframe.style.display = "none";
	iframe.src = blobUrl;

	iframe.onload = () => {
		iframe.contentWindow?.focus();
		iframe.contentWindow?.print();
	};

	document.body.appendChild(iframe);

	window.setTimeout(() => {
		iframe.remove();
		window.URL.revokeObjectURL(blobUrl);
	}, 60000);
};

export default { downloadFootHealthReport, printFootHealthReport };
